import './index.css';

export default function Spectrum() {
  return (
    <div className="spectrum-container flex items-center justify-center h-spectrum w-spectrum bg-bpPrimary rounded-full cursor-pointer">
      <div className="spectrum flex items-center">
        <div className="bar bg-white opacity-50 w-spectrum-bar rounded-md"></div>
        <div className="bar bg-white opacity-50 w-spectrum-bar rounded-md"></div>
        <div className="bar bg-white opacity-50 w-spectrum-bar rounded-md"></div>
      </div>
    </div>
  )
}
